import React, { createContext, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { buildApiUrl } from '../../config/api';

export const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState(
    localStorage.getItem('locale') || i18n.language || 'en'
  );

  // Initialize locale on mount
  useEffect(() => {
    i18n.changeLanguage(locale);
  }, []);

  const changeLocale = async (newLocale) => {
    if (!['es', 'en', 'ca'].includes(newLocale)) {
      return;
    }

    try {
      // Change i18next language
      await i18n.changeLanguage(newLocale);

      // Save to localStorage
      localStorage.setItem('locale', newLocale);

      // Update state
      setLocale(newLocale);

      // Notify backend to persist locale in session/cookie
      try {
        await fetch(buildApiUrl('/api/locale'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': newLocale
          },
          credentials: 'include',
          body: JSON.stringify({ locale: newLocale })
        });
      } catch (e) {
      }
    } catch (error) {
    }
  };

  return (
    <LocaleContext.Provider value={{ locale, changeLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

// Custom hook to use the locale context
export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};
